<template>
<div class="bg-open">
  <div style="height: 20px;margin-right: 30px;padding-top: 20px;text-align: right">
    <img @click="closeWindow()" style="cursor:pointer;" src="../../../assets/health/windows_close.png">
  </div>
  <div style="margin: -10px 30px 0">
    <el-date-picker v-fixZoom
      size="small"
      :clearable="false"
      v-model="sendDate"
      type="daterange"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="datePickerOptions"
      style="margin-right: 10px; width: 400px">
    </el-date-picker>&nbsp;&nbsp;
    <el-button size="small" type="primary" @click="queryList()">查询</el-button>
  </div>
  <div>
    <div style="height: 10px"></div>
<!--    <div style="height: 50px"></div>-->
<!--    <div style="height: 20px;margin: 0 30px;line-height: 20px;font-size: 12px">-->
<!--      <img v-if="deviceRow.isOnline === 1" style="vertical-align: middle" src="../../../assets/health/icon_time.png">-->
<!--      <img v-if="deviceRow.isOnline === 0" style="vertical-align: middle" src="../../../assets/health/icon_time_leave.png">-->
<!--      <span :style="{color: deviceRow.isOnline === 0 ? '#666666' : '#d3e2e6'}" style="vertical-align: middle">{{ deviceRow.time }}</span>-->
<!--    </div>-->
    <div class="bg-top">
      <el-row style="margin: 0 30px">
        <el-col :span="6">
          <div class="row-list">
            <img v-if="deviceRow.isOnline === 1" style="vertical-align: middle" src="../../../assets/health/information_imei.png">
            <img v-if="deviceRow.isOnline === 0" style="vertical-align: middle" src="../../../assets/health/information_imei_leave.png">
            <span :style="{color: deviceRow.isOnline === 0 ? '#666666' : '#d3e2e6'}" style="vertical-align: middle">{{ deviceRow.deviceid }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="row-list">
            <img v-if="deviceRow.isOnline === 1" style="vertical-align: middle" src="../../../assets/health/information_phone.png">
            <img v-if="deviceRow.isOnline === 0" style="vertical-align: middle" src="../../../assets/health/information_phone_leave.png">
            <span :style="{color: deviceRow.isOnline === 0 ? '#666666' : '#d3e2e6'}" style="vertical-align: middle">{{ deviceRow.h_phone }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="row-list">
            <img v-if="deviceRow.isOnline === 1" style="vertical-align: middle" src="../../../assets/health/information_address.png">
            <img v-if="deviceRow.isOnline === 0" style="vertical-align: middle" src="../../../assets/health/information_address_leave.png">
            <span :style="{color: deviceRow.isOnline === 0 ? '#666666' : '#d3e2e6'}" style="vertical-align: middle">{{ deviceRow.h_address }}</span>
          </div>
        </el-col>
      </el-row>
<!--      <el-row v-if="deviceRow.healthtype === 1">-->
<!--        <el-col :span="6">-->
<!--          <div class="item-bg">-->
<!--            <img style="vertical-align: bottom" title="心率" v-if="deviceRow.isOnline === 1" src="/static/health/icon_heart.png">-->
<!--            <img style="vertical-align: bottom" title="心率" v-if="deviceRow.isOnline === 0" src="/static/health/icon_heart_leave.png">-->
<!--            <span :style="{color: deviceRow.isOnline === 0 ? '#731300' : '#ff2a00'}">{{ deviceRow.sleep_heartbeat }}次/分</span>-->
<!--          </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="item-bg">-->
<!--            <img style="vertical-align: bottom" title="呼吸" v-if="deviceRow.isOnline === 1" src="/static/health/icon_breathing.png">-->
<!--            <img style="vertical-align: bottom" title="呼吸" v-if="deviceRow.isOnline === 0" src="/static/health/icon_breathing_leave.png">-->
<!--            <span :style="{color: deviceRow.isOnline === 0 ? '#676800' : '#e5e600'}">{{ deviceRow.sleep_breathe }}次/分</span>-->
<!--          </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="item-bg">-->
<!--            <img style="vertical-align: bottom" v-if="deviceRow.sleep_inbed === 1 && deviceRow.isOnline === 1" src="/static/health/icon_bed.png">-->
<!--            <img style="vertical-align: bottom" v-if="deviceRow.sleep_inbed === 1 && deviceRow.isOnline === 0" src="/static/health/icon_bed_leave.png">-->
<!--            <img style="vertical-align: bottom" v-if="deviceRow.sleep_inbed === 0 && deviceRow.isOnline === 1" src="/static/health/icon_leave_bed.png">-->
<!--            <img style="vertical-align: bottom" v-if="deviceRow.sleep_inbed === 0 && deviceRow.isOnline === 0" src="/static/health/icon_leave_bed_leave.png">-->
<!--            <span>-->
<!--              <span :style="{color: deviceRow.isOnline === 0 ? '#006a73' : '#00eaff'}" v-if="deviceRow.sleep_inbed === 1">在床</span>-->
<!--              <span :style="{color: deviceRow.isOnline === 0 ? '#006845' : '#00e699'}" v-if="deviceRow.sleep_inbed === 0">离床</span>-->
<!--            </span>-->
<!--          </div>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <div class="item-bg">-->
<!--            <img style="vertical-align: bottom" v-if="deviceRow.isOnline === 1" src="/static/health/icon_turnover.png">-->
<!--            <img style="vertical-align: bottom" v-if="deviceRow.isOnline === 0" src="/static/health/icon_turnover_leave.png">-->
<!--            <span :style="{color: deviceRow.isOnline === 0 ? '#456800' : '#99e500'}">-->
<!--            <span v-if="deviceRow.sleep_status === 1">翻身</span>-->
<!--            <span v-if="deviceRow.sleep_status === 0">正常</span>-->
<!--          </span>-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <div v-else style="text-align: center">-->
<!--        <img :src="getImgType0(deviceRow)">-->
<!--        <span :style="{color: deviceRow.isOnline === 0 ? '#5c003d' : '#f726b0'}" v-if="deviceRow.isHome === 0">离家</span>-->
<!--        <span v-else>-->
<!--          <span :style="{color: deviceRow.isOnline === 0 ? '#004d73' : '#00aaff'}" v-if="deviceRow.radar_status === 0">休息</span>-->
<!--          <span :style="{color: deviceRow.isOnline === 0 ? '#734900' : '#ffa200'}" v-if="deviceRow.radar_status === 1">运动</span>-->
<!--        </span>-->
<!--      </div>-->
    </div>
    <div v-if="deviceRow.healthtype === 1" class="chart-content">
      <el-row>
        <el-col :span="12">
          <div class="chart-list">
            <heart-beat ref="heartbeat"></heart-beat>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-list">
            <breathe ref="breathe"></breathe>
          </div>
        </el-col>
      </el-row>
      <div style="height: 10px"></div>
      <el-row>
        <el-col :span="12">
          <div class="chart-list">
            <in-bed :deviceRow="deviceRow" ref="inbed"></in-bed>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chart-list">
            <status :deviceRow="deviceRow" ref="status"></status>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="margin: 0 25px;" v-else>
      <div class="chart-list1">
        <radar-chart ref="radar"></radar-chart>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {querysleephistorydata, queryradarhistorydata} from '../../../api/health'
import breathe from '../healthComponents/breathe'
import inBed from '../healthComponents/inBed'
import status from '../healthComponents/status'
import heartBeat from '../healthComponents/heartBeat'
import radarChart from '../healthComponents/radarChart'
export default {
  name: 'chartOpen',
  components: {breathe, inBed, status, heartBeat, radarChart},
  model: {
    prop: 'historyOpen',
    event: 'change'
  },
  props: {
    deviceRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      sendDate: [],
      datePickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      imgType0: [
        {url0: '/static/health/icon_rest_leave.png', url1: '/static/health/icon_rest.png'}, // 0休息（呼吸）
        {url0: '/static/health/icon_motion_leave.png', url1: '/static/health/icon_motion.png'}, // 1运动（动作）
        {url0: '/static/health/icon_leave_home_leave.png', url1: '/static/health/icon_leave_home.png'} // 2离家
      ]
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let format = new Date().format('yyyyMMdd')
    this.sendDate = [format, format]
    if (this.deviceRow.healthtype === 1) { // 睡眠
      this.getSleepHistoryData()
    } else { // 0雷达
      this.getRadarHistoryData()
    }
  },
  methods: {
    queryList () {
      if (this.deviceRow.healthtype === 1) { // 睡眠
        this.getSleepHistoryData()
      } else { // 0雷达
        this.getRadarHistoryData()
      }
    },
    getSleepHistoryData () {
      let data = {
        did: this.deviceRow.did,
        imei: this.deviceRow.deviceid,
        from: this.sendDate[0] + '000000',
        to: this.sendDate[1] + '235959'
      }
      querysleephistorydata(data).then(res => {
        this.$refs.heartbeat.getStartData(res.data.sleepdata)
        this.$refs.breathe.getStartData(res.data.sleepdata)
        this.$refs.inbed.getStartData(res.data.sleepdata)
        this.$refs.status.getStartData(res.data.sleepdata)
      }).catch(() => {})
    },
    getRadarHistoryData () {
      let data = {
        did: this.deviceRow.did,
        imei: this.deviceRow.deviceid,
        from: this.sendDate[0] + '000000',
        to: this.sendDate[1] + '235959'
      }
      queryradarhistorydata(data).then(res => {
        this.$refs.radar.getStartData(res.data.radardata)
      }).catch(() => {})
    },
    getImgType0 (item) {
      let isHome = item.isHome
      let img = ''
      if (isHome === 0) {
        if (item.isOnline === 0) {
          img = this.imgType0[2].url0
        } else {
          img = this.imgType0[2].url1
        }
      } else {
        if (item.radar_status === 'tx') {
          if (item.isOnline === 0) {
            img = this.imgType0[0].url0
          } else {
            img = this.imgType0[0].url1
          }
        } else if (item.radar_status === 'out') {
          if (item.isOnline === 0) {
            img = this.imgType0[1].url0
          } else {
            img = this.imgType0[1].url1
          }
        }
      }
      return img
    },
    closeWindow () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>
.bg-open{
  height: 670px;
  background-color: #002040;;
  border: 1px solid #00eaff;
}
.bg-top{
  height: 50px;
  margin: 0 30px 10px;
  background: url("../../../assets/health/windows_equipment_bg.png") no-repeat;
  background-size: 100% 100%;
}
.row-list{
  height: 50px;
  line-height: 50px;
}
.item-bg{
  padding-top: 10px;
  font-size: 20px;
  text-align: center;
}
.item-bg img{
  margin-right: 5px;
}
.chart-content{
  height: 510px;
  margin: 0 25px;
}
.chart-list{
  height: 250px;
  margin: 0 5px;
  background: url("../../../assets/health/windows_numerical_bg.png") no-repeat;
  background-size: 100% 100%;
}
.chart-list1{
  height: 500px;
  margin: 0 5px;
  background: url("../../../assets/health/windows_numerical_bg.png") no-repeat;
  background-size: 100% 100%;
}
.masonry {
  -moz-column-count: 2; /* Firefox */
  -webkit-column-count: 2; /* Safari 和 Chrome */
  column-count: 2;
  -moz-column-gap: 60px;
  -webkit-column-gap: 60px;
  column-gap: 60px;
  margin: 20px 60px;
  /*background-color: #3EA0D2;*/
  color: white;
}
@media screen and (max-width: 1500px) {
  .masonry {
    margin: 20px 30px;
    /*background-color: #cccccc;*/
  }
}
.item {
  /*padding: 32px;*/
  margin-bottom: 20px;
  -moz-page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
  break-inside: avoid;
  background: #f60;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/chartOpen.vue